/**
 * LITE PLUS CTA
 *
 * Форма несёт вариант товара страницы (предложение с подпиской, например
 * yasmina-kids-12mon-bundle), поэтому «Buy with subscription» и sticky-бар
 * внизу кладут в корзину именно его.
 *
 * «Buy without subscription» кладёт обычный yasmina-kids-lite того же цвета,
 * что выбран, и показывает его цену. Соответствие «вариант страницы →
 * вариант yasmina-kids-lite» приходит из секции в window.__litePlusPlainVariantMap.
 */
(function () {
  var root = document.querySelector("[data-lite-plus-cta]");
  if (!root) return;

  var btnPlain = root.querySelector("[data-add-without-subscription]");
  if (!btnPlain) return;

  var labelEl = btnPlain.querySelector("[data-lp-plain-label]");
  var isSubmitting = false;

  function plainVariantMap() {
    return window.__litePlusPlainVariantMap || {};
  }

  function selectedPageVariantId() {
    var hidden = document.querySelector("input[data-variant-id]");
    return hidden ? hidden.value : null;
  }

  function currentPlainVariant() {
    var pageId = selectedPageVariantId();
    if (!pageId) return null;
    return plainVariantMap()[pageId] || null;
  }

  function getQuantity() {
    var input = document.querySelector("[data-quantity-input]");
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function formatMoney(cents) {
    var whole = Math.floor(cents / 100);
    var frac = cents % 100;
    return frac > 0
      ? whole + "." + String(frac).padStart(2, "0")
      : String(whole);
  }

  /**
   * Свотчи цвета переписывают скрытый инпут в theme.js на клике, поэтому здесь
   * мы перечитываем его после того, как тот обработчик отработал, и приводим
   * подпись и доступность кнопки к выбранному цвету.
   */
  function syncToSelectedColour() {
    var variant = currentPlainVariant();

    if (!variant) {
      btnPlain.disabled = true;
      btnPlain.setAttribute("aria-disabled", "true");
      return;
    }

    if (labelEl && typeof variant.price === "number") {
      var currency = window.__litePlusCurrency || "";
      labelEl.textContent =
        "Buy without AI subscription — " +
        currency +
        " " +
        formatMoney(variant.price);
    }

    btnPlain.disabled = !variant.available;
    if (variant.available) {
      btnPlain.removeAttribute("aria-disabled");
    } else {
      btnPlain.setAttribute("aria-disabled", "true");
    }
  }

  function openCartDrawer(responseData) {
    var cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(responseData);
    } else if (cartDrawer) {
      cartDrawer.classList.add("sf-cart-opened");
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }

    if (responseData && responseData.item_count !== undefined) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = responseData.item_count;
        el.style.display = responseData.item_count > 0 ? "flex" : "none";
      });
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: responseData }),
      );
    }
  }

  async function parseCartResponse(response) {
    var contentType = response.headers.get("content-type") || "";
    var isJsonLike =
      contentType.includes("application/json") ||
      contentType.includes("text/javascript") ||
      contentType.includes("application/javascript");

    if (!response.ok) {
      var errorText = await response.text();
      throw new Error(
        response.status === 429
          ? "Too many cart requests. Please wait a second and try again."
          : errorText || "Error adding to cart",
      );
    }

    if (!isJsonLike) {
      var text = await response.text();
      throw new Error(
        text.includes("Verifying your connection")
          ? "Cart request was blocked by site protection. Please wait a moment and try again."
          : "Unexpected cart response",
      );
    }

    var payload = await response.text();
    try {
      return JSON.parse(payload);
    } catch (error) {
      throw new Error("Failed to parse cart response");
    }
  }

  async function addToCart(items) {
    var cartDrawer = document.querySelector("cart-drawer");
    var body = { items: items };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      body.sections = cartDrawer
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(",");
      body.sections_url = window.location.pathname;
    }

    var response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    });

    var data = await parseCartResponse(response);
    if (data.status) {
      throw new Error(
        data.description || data.message || "Error adding to cart",
      );
    }
    return data;
  }

  /**
   * Предложение с подпиской продаётся по одному на заказ, поэтому этот шаблон
   * сам решает, что класть в корзину, и забирает submit у product-form.js целиком:
   *
   *   с подпиской уже в корзине  -> N обычных yasmina-kids-lite того же цвета
   *   его нет, N > 1             -> 1 товар страницы + (N-1) обычных
   *   его нет, N = 1             -> 1 товар страницы
   *
   * Слушатель висит на document в фазе перехвата, чтобы сработать раньше
   * обработчика формы. Sticky-бар внизу диспатчит на форме настоящий submit,
   * поэтому ловится тем же кодом.
   */
  function subscriptionVariantIds() {
    return (window.__yasminaSingletonVariantIds || []).map(String);
  }

  async function cartHasSubscription() {
    var ids = subscriptionVariantIds();
    if (!ids.length) return false;
    try {
      var res = await fetch("/cart.js", {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) return false;
      var cart = await res.json();
      return (cart.items || []).some(function (item) {
        return ids.indexOf(String(item.variant_id)) !== -1;
      });
    } catch (err) {
      // Не смогли прочитать корзину — ведём себя как раньше, без разбивки.
      return false;
    }
  }

  async function addFromForm(pageId, plainVariant) {
    if (isSubmitting) return;
    isSubmitting = true;

    try {
      var qty = getQuantity();
      var hasSub = await cartHasSubscription();
      var items;

      if (hasSub) {
        items = [{ id: parseInt(plainVariant.id, 10), quantity: qty }];
      } else if (qty > 1) {
        items = [
          { id: parseInt(pageId, 10), quantity: 1 },
          { id: parseInt(plainVariant.id, 10), quantity: qty - 1 },
        ];
      } else {
        items = [{ id: parseInt(pageId, 10), quantity: 1 }];
      }

      var data = await addToCart(items);
      openCartDrawer(data);

      var quantityInput = document.querySelector("[data-quantity-input]");
      if (quantityInput) quantityInput.value = 1;
    } catch (err) {
      console.error("LITE PLUS add error:", err);
      if (window.NotificationManager) {
        window.NotificationManager.error(err.message);
      } else {
        alert(err.message);
      }
    } finally {
      isSubmitting = false;
      syncToSelectedColour();
    }
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form =
        e.target && e.target.closest
          ? e.target.closest("[data-product-form]")
          : null;
      if (!form) return;

      var pageId = selectedPageVariantId();
      if (!pageId) return;

      // Нет пары обычного Lite в этом цвете — отдаём submit форме как есть.
      var plainVariant = currentPlainVariant();
      if (!plainVariant || !plainVariant.available) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(pageId, plainVariant);
    },
    true,
  );

  btnPlain.addEventListener("click", async function (e) {
    e.preventDefault();
    if (isSubmitting) return;

    var variant = currentPlainVariant();
    if (!variant || !variant.available) return;

    isSubmitting = true;
    btnPlain.disabled = true;

    try {
      var data = await addToCart([
        { id: parseInt(variant.id, 10), quantity: getQuantity() },
      ]);
      openCartDrawer(data);

      var quantityInput = document.querySelector("[data-quantity-input]");
      if (quantityInput) quantityInput.value = 1;
    } catch (err) {
      console.error("LITE PLUS add without subscription error:", err);
      if (window.NotificationManager) {
        window.NotificationManager.error(err.message);
      } else {
        alert(err.message);
      }
    } finally {
      isSubmitting = false;
      syncToSelectedColour();
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-variant-id]:not([name])")) {
      setTimeout(syncToSelectedColour, 0);
    }
  });

  syncToSelectedColour();
})();
